import { useContext } from 'react';
import UserProfileContext from '@layouts/UserProfileLayout/UserProfileContext';
import TaskList from './TaskList';
import s from './Home.module.scss';

const UserProfileHome: React.FC = () => {
  const { creatorId } = useContext(UserProfileContext);
  if (!creatorId) {
    return null;
  }

  return (
    <main className={s.main}>
      <TaskList creatorId={creatorId} />
    </main>
  );
};

export default UserProfileHome;
